// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";

const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return(
        <section id="presentation" className="text-center space-ptb">
            <div className="container">
                <h1 className="mb-4">{t('homePage.presentation.title')}</h1>
                <p>{t('homePage.presentation.para1')}</p>
                <p>{t('homePage.presentation.para2')}</p>
                <ul className="list-unstyled d-inline-block text-left pl-5">
                    <li className="mb-2" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.listElement1') as string }}></li>
                    <li className="mb-2" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.listElement2') as string }}></li>
                    <li className="mb-2" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.listElement3') as string }}></li>
                </ul>
                <p>{t('homePage.presentation.pre-motto')}</p>
                <p className="lead heart" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.motto') as string }}></p>
            </div>
        </section>
    )
}
export default Presentation;